const React = require('react');
const { View, Text, StyleSheet, TouchableOpacity, Image } = require('react-native');

// Show web simulated Google Ad overlay
let activeAdOverlay = null;

function showWebAdOverlay({ title = 'Google AdMob Interstitial', onReward, onClose }) {
  if (typeof document === 'undefined') {
    if (onReward) onReward({ amount: 100, type: 'coins' });
    if (onClose) onClose();
    return;
  }

  // Remove any existing ad overlay
  const existing = document.getElementById('google-ad-web-overlay');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.id = 'google-ad-web-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    z-index: 999999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justifyContent: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    color: white;
    user-select: none;
  `;

  let countdown = 5;

  overlay.innerHTML = `
    <div style="position: absolute; top: 16px; left: 20px; display: flex; align-items: center; gap: 8px;">
      <span style="background: #fbbc04; color: #202124; font-size: 11px; font-weight: bold; padding: 2px 6px; border-radius: 4px;">Ad</span>
      <span style="font-size: 14px; color: #9aa0a6;">Google AdMob</span>
    </div>
    
    <div id="ad-timer-badge" style="position: absolute; top: 16px; right: 20px; background: rgba(255,255,255,0.15); padding: 6px 14px; border-radius: 20px; font-size: 13px; font-weight: 600; color: #fff;">
      Reward in ${countdown}s
    </div>

    <div style="width: 90%; max-width: 400px; background: #202124; border-radius: 16px; overflow: hidden; box-shadow: 0 12px 36px rgba(0,0,0,0.6); text-align: center; padding: 24px 20px;">
      <div style="width: 80px; height: 80px; margin: 0 auto 16px; background: linear-gradient(135deg, #4285f4, #34a853); border-radius: 20px; display: flex; align-items: center; justify-content: center; font-size: 36px;">
        🎲
      </div>
      <h2 style="margin: 0 0 8px; font-size: 22px; font-weight: 700; color: #fff;">Ludo Voice - Play & Win</h2>
      <p style="margin: 0 0 20px; font-size: 14px; color: #bdc1c6; line-height: 1.4;">
        Connect with friends in live voice rooms and win huge daily jackpot coins!
      </p>
      
      <div style="background: #303134; border-radius: 12px; padding: 12px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-around;">
        <div>
          <div style="font-size: 18px; font-weight: bold; color: #fbbc04;">★ 4.8</div>
          <div style="font-size: 11px; color: #9aa0a6;">Rating</div>
        </div>
        <div style="width: 1px; height: 24px; background: #5f6368;"></div>
        <div>
          <div style="font-size: 18px; font-weight: bold; color: #34a853;">1M+</div>
          <div style="font-size: 11px; color: #9aa0a6;">Downloads</div>
        </div>
      </div>

      <button id="ad-install-btn" style="width: 100%; padding: 14px; background: #1a73e8; color: #fff; border: none; border-radius: 24px; font-size: 16px; font-weight: 600; cursor: pointer; transition: background 0.2s;">
        Install Now
      </button>
    </div>

    <button id="ad-close-btn" style="display: none; position: absolute; top: 14px; right: 20px; background: rgba(255,255,255,0.25); color: #fff; border: none; width: 36px; height: 36px; border-radius: 50%; font-size: 18px; font-weight: bold; cursor: pointer; line-height: 36px; text-align: center;">
      ✕
    </button>
  `;

  document.body.appendChild(overlay);

  const timerBadge = overlay.querySelector('#ad-timer-badge');
  const closeBtn = overlay.querySelector('#ad-close-btn');
  const installBtn = overlay.querySelector('#ad-install-btn');

  installBtn.onclick = () => {
    window.open('https://play.google.com/store/apps', '_blank');
  };

  const interval = setInterval(() => {
    countdown -= 1;
    if (countdown > 0) {
      timerBadge.innerText = `Reward in ${countdown}s`;
    } else {
      clearInterval(interval);
      timerBadge.style.display = 'none';
      closeBtn.style.display = 'block';
      if (onReward) onReward({ amount: 100, type: 'coins' });
    }
  }, 1000);

  closeBtn.onclick = () => {
    clearInterval(interval);
    overlay.remove();
    if (onClose) onClose();
  };
}

class AdInstance {
  constructor(unitId) {
    this.unitId = unitId;
    this.listeners = new Map();
    this.loaded = false;
  }

  addAdEventListener(eventType, handler) {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, new Set());
    }
    this.listeners.get(eventType).add(handler);

    // If already loaded and listener added for LOADED, trigger it
    if (eventType === AdEventType.LOADED && this.loaded) {
      setTimeout(() => handler(), 50);
    }

    return () => {
      if (this.listeners.has(eventType)) {
        this.listeners.get(eventType).delete(handler);
      }
    };
  }

  _emit(eventType, data) {
    if (this.listeners.has(eventType)) {
      this.listeners.get(eventType).forEach((handler) => {
        try {
          handler(data);
        } catch (e) {
          console.error('Ad listener error:', e);
        }
      });
    }
  }

  load() {
    this.loaded = false;
    setTimeout(() => {
      this.loaded = true;
      this._emit(AdEventType.LOADED);
      this._emit(RewardedAdEventType.LOADED);
    }, 200);
  }

  async show() {
    this._emit(AdEventType.OPENED);
    showWebAdOverlay({
      title: 'Google AdMob Ad',
      onReward: (reward) => {
        this._emit(RewardedAdEventType.EARNED_REWARD, reward);
      },
      onClose: () => {
        this.loaded = false;
        this._emit(AdEventType.CLOSED);
      },
    });
  }
}

const BannerAd = (props) => {
  return React.createElement(View, { ...props, style: [{ minHeight: 0, height: 0, overflow: 'hidden' }, props?.style] });
};

const BannerAdSize = {
  BANNER: 'BANNER',
  FULL_BANNER: 'FULL_BANNER',
  LARGE_BANNER: 'LARGE_BANNER',
  LEADERBOARD: 'LEADERBOARD',
  MEDIUM_RECTANGLE: 'MEDIUM_RECTANGLE',
  ADAPTIVE_BANNER: 'ADAPTIVE_BANNER',
  ANCHORED_ADAPTIVE_BANNER: 'ANCHORED_ADAPTIVE_BANNER',
  INLINE_ADAPTIVE_BANNER: 'INLINE_ADAPTIVE_BANNER',
  WIDE_SKYSCRAPER: 'WIDE_SKYSCRAPER',
};

const TestIds = {
  BANNER: 'ca-app-pub-3940256099942544/6300978111',
  INTERSTITIAL: 'ca-app-pub-3940256099942544/1033173712',
  REWARDED: 'ca-app-pub-3940256099942544/5224354917',
  APP_OPEN: 'ca-app-pub-3940256099942544/3419835294',
  REWARDED_INTERSTITIAL: 'ca-app-pub-3940256099942544/6978759866',
};

const AdEventType = {
  LOADED: 'loaded',
  ERROR: 'error',
  OPENED: 'opened',
  CLICKED: 'clicked',
  CLOSED: 'closed',
};

const RewardedAdEventType = {
  LOADED: 'loaded',
  EARNED_REWARD: 'earned_reward',
};

const AppOpenAdEventType = {
  LOADED: 'loaded',
  CLOSED: 'closed',
};

const InterstitialAd = {
  createForAdRequest: (unitId) => {
    const ad = new AdInstance(unitId || TestIds.INTERSTITIAL);
    ad.load();
    return ad;
  },
};

const RewardedAd = {
  createForAdRequest: (unitId) => {
    const ad = new AdInstance(unitId || TestIds.REWARDED);
    ad.load();
    return ad;
  },
};

const AppOpenAd = {
  createForAdRequest: (unitId) => {
    const ad = new AdInstance(unitId || TestIds.APP_OPEN);
    ad.load();
    return ad;
  },
};

const RewardedInterstitialAd = {
  createForAdRequest: (unitId) => {
    const ad = new AdInstance(unitId || TestIds.REWARDED_INTERSTITIAL);
    ad.load();
    return ad;
  },
};

const useRewardedAd = () => {
  const [isLoaded, setIsLoaded] = React.useState(true);
  const [isClosed, setIsClosed] = React.useState(false);
  const [reward, setReward] = React.useState(null);

  return {
    isLoaded,
    isClosed,
    load: () => setIsLoaded(true),
    show: () => {
      showWebAdOverlay({
        onReward: (r) => setReward(r),
        onClose: () => setIsClosed(true),
      });
    },
    reward,
  };
};

const useInterstitialAd = () => {
  const [isLoaded, setIsLoaded] = React.useState(true);
  const [isClosed, setIsClosed] = React.useState(false);

  return {
    isLoaded,
    isClosed,
    load: () => setIsLoaded(true),
    show: () => {
      showWebAdOverlay({
        onClose: () => setIsClosed(true),
      });
    },
  };
};

const useAppOpenAd = () => ({
  isLoaded: true,
  isClosed: false,
  load: () => {},
  show: () => {},
});

const useRewardedInterstitialAd = () => useRewardedAd();

const useForeground = (_ref) => {};

const AdsConsent = {
  requestInfoUpdate: async () => ({}),
  showForm: async () => ({}),
  loadAndShowConsentFormIfRequired: async () => ({}),
  getStatus: async () => 'NOT_REQUIRED',
};

const AdsConsentStatus = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  REQUIRED: 'REQUIRED',
  OBTAINED: 'OBTAINED',
  UNKNOWN: 'UNKNOWN',
};

const mobileAds = () => ({
  initialize: async () => {},
  setRequestConfiguration: async () => {},
});

module.exports = {
  BannerAd,
  BannerAdSize,
  TestIds,
  AdEventType,
  RewardedAdEventType,
  AppOpenAdEventType,
  InterstitialAd,
  RewardedAd,
  AppOpenAd,
  RewardedInterstitialAd,
  useRewardedAd,
  useInterstitialAd,
  useAppOpenAd,
  useRewardedInterstitialAd,
  useForeground,
  AdsConsent,
  AdsConsentStatus,
  MobileAds: mobileAds,
  default: mobileAds,
};
